import {useContext} from 'react';
import RaidTeamTable from '../components/raidTeam/RaidTeamTable'
import AddRaidTeam from '../components/raidTeam/AddRaidTeam'
import AppContext from '../contexts/AppContext';
import NavBar from '../components/appbar/NavBar'
import { Box, Grid } from "@mui/material";

export default function SessionList(){

  let {raidTeams} = useContext(AppContext);

  return(
    <Box>
    <NavBar pageName={'Raid Teams'}/>
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <AddRaidTeam/>
      </Grid>
    </Grid>
    <RaidTeamTable data={raidTeams}/>
    </Box>
  )
}